import { PlusIcon } from '@heroicons/react/24/outline';
import { BotCard } from './BotCard';
import config from '../../../../config';
import { TerminalPage } from '../../side-panels/TerminalPage';
import { Link, useParams } from 'react-router-dom';
import Button from 'modules/shared-components/button/button';
import { useUserState } from 'modules/user/UserContext';
import { BotType } from 'api/types/httpsTypes/dex-bot';
import {
  BOT_SIDEBAR,
  MAIN_INFO,
  Tabs,
} from '../../components/layout/SIDEBAR_CONST';
import PageTemplate from '../../components/layout';
import { useSelectedChain } from '../../components/chains/getChains';

const Bots = () => {
  const { user } = useUserState();
  const { tab: activeTab } = useParams<{ tab: Tabs }>();

  return (
    <PageTemplate
      sidebar={BOT_SIDEBAR(useSelectedChain())}
      buttonContainerClass="xxs:flex xxs:justify-between xxs:items-center"
      button={
        user ? (
          <div className="flex">
            <Button
              as={Link}
              to={`/dex/bots/${activeTab}/new`}
              variant="dexNeutral"
              size="large"
              className="m-0 xxs:p-1 flex space-x-2 lg:space-x-1 normal-case w-full lg:w-auto xxs:text-sm lg:text-xs	"
            >
              <PlusIcon className="h-6 w-6 lg:h-4 lg:w-4" />
              <div className="hidden lg:block">
                New{' '}
                {activeTab === Tabs.WalletCopyTrading
                  ? 'Wallet Copy'
                  : activeTab === Tabs.TgCopyTrading
                  ? 'Telegram Calls'
                  : 'Volatility'}{' '}
                Bot
              </div>
            </Button>
          </div>
        ) : undefined
      }
      mainInfo={MAIN_INFO.bot.filter((info) => info.activeTab === activeTab)}
      pages={[
        ...(config.isTelegramBrowser
          ? [
              {
                href: '/dex/navigation',
                name: 'Navigation',
              },
            ]
          : []),
        {
          href: `/dex/bots`,
          name: 'Bots',
        },
      ]}
    >
      <TerminalPage>
        <div className="h-full">
          <BotCard
            botType={
              activeTab === Tabs.WalletCopyTrading
                ? BotType.Wallet
                : activeTab === Tabs.VolatilityBot
                ? BotType.Volatility
                : BotType.Telegram
            }
          />
        </div>
      </TerminalPage>
    </PageTemplate>
  );
};

export default Bots;
